var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_loading loader-area",staticStyle:{"position":"absolute","left":"0","right":"0","top":"0","bottom":"0","margin":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }